import type { TinyColor } from '@ctrl/tinycolor';

export type BdColorFactoryType =
  | 'lightness'
  | 'judgement'
  | 'scheme'
  | 'custom';

export abstract class BdColorFactory {
  public abstract type: BdColorFactoryType;

  /**
   * Get the color for given value in min/max range.
   * @param value
   * @param minValue
   * @param maxValue
   */
  public abstract getColorForValue(
    value: number,
    minValue: number,
    maxValue: number,
  ): TinyColor | null;

  public abstract clone(): BdColorFactory;

  public abstract toJSON(): unknown;

  public abstract equals(other: BdColorFactory): boolean;

  /**
   * Calculate percentage with dynamic minValue and maxValue
   * @param value
   * @param minValue
   * @param maxValue
   * @protected
   * @see https://math.stackexchange.com/questions/2595432/how-to-determine-percent-of-a-range
   */
  protected percentage(
    value: number,
    minValue: number,
    maxValue: number,
  ): number {
    return (value - minValue) / (maxValue - minValue);
  }
}

export const BD_COLOR_FACTORY_TYPE_DISPLAY_NAME: Record<
  BdColorFactoryType,
  string
> = {
  custom: 'Eigene Farben',
  scheme: 'Farbverlauf',
  lightness: 'Helligkeitsverlauf',
  judgement: 'Bewertung',
};
